// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"256":"1ae537b2","971":"5999667a"}[chunkId] + ".css";
};